import { useEffect, useMemo, useState } from 'react';
import ReactAvatar from 'react-avatar';
import { Avatar as AntdAvatar } from 'antd';
import styles from './Avatar.module.scss';
import { generateColorFromName, hexToRgba } from './helper';

const Avatar = ({ name = '', src = '', size = 30, customAvatarStyle = {}, isSystem = false, ...rest }) => {
  const letter = name ? name?.charAt(0)?.toUpperCase() : 'A';
  const [imgSrc, setImgSrc] = useState(src);
  const isImage = imgSrc && imgSrc.length > 0;

  useEffect(() => setImgSrc(src), [src]);

  const hexColor = useMemo(() => generateColorFromName(name || ''), [name]);

  if (isImage)
    return (
      <AntdAvatar
        size={size}
        style={{
          '--ant-color-text-placeholder': isImage ? 'transparent' : '#568c94',
          fontWeight: 700,
          flexShrink: 0,
        }}
        onError={() => setImgSrc(null)}
        src={isImage ? imgSrc : undefined}
        {...rest}
      >
        {!isImage ? letter : null}
      </AntdAvatar>
    );

  return (
    <>
      {isSystem && name ? (
        <div
          style={{
            border: `1px solid ${hexColor}`,
            color: hexColor,
            backgroundColor: hexToRgba(hexColor),
            fontSize: rest?.lastName ? '12px' : '15px',
            width: size,
            height: size,
            minWidth: size,
            minHeight: size,
            maxWidth: size,
            maxHeight: size,
            flex: `0 0 ${size}px`,
            backdropFilter: rest?.glass ? 'blur(6px)' : undefined,
            WebkitBackdropFilter: rest?.glass ? 'blur(6px)' : undefined,
          }}
          className={styles.avatar}
        >
          {rest?.icon && <div style={{ position: 'absolute', top: -7, right: -6 }}>{rest?.icon}</div>}
          {name?.trim()[0]}
          {rest?.lastName?.trim()[0]}
        </div>
      ) : (
        <ReactAvatar
          name={name?.trim()[0] || '?'}
          title=""
          col
          size={size}
          textSizeRatio={2}
          round
          style={{ fontFamily: "'Work Sans', sans-serif", ...customAvatarStyle }}
          {...rest}
        />
      )}
    </>
  );
};

export default Avatar;
